import { STAGE_META, STAGE_ORDER } from '../qualityConfig';

export const EngagementBar = ({ u }) => {
    if (!u.total) return <span className="text-xs text-muted-foreground" data-testid={`team-engagement-${u.id}`}>No tasks yet</span>;
    const parts = STAGE_ORDER.map((id) => ({ id, n: u[id] || 0 })).filter((p) => p.n);
    return (
        <div className="min-w-[200px] space-y-1.5" data-testid={`team-engagement-${u.id}`}>
            <div className="flex h-2 overflow-hidden rounded-full bg-muted">
                {parts.map((p) => (
                    <div key={p.id} className={`${STAGE_META[p.id].bar} transition-[width] duration-500`} style={{ width: `${(p.n / u.total) * 100}%` }} title={`${p.n} ${STAGE_META[p.id].label.toLowerCase()}`} />
                ))}
            </div>
            <div className="flex flex-wrap gap-x-2.5 gap-y-0.5 text-[11px]">
                {parts.map((p) => (
                    <span key={p.id} className={`inline-flex items-center gap-1 ${STAGE_META[p.id].text}`} data-testid={`team-engagement-${u.id}-${p.id}`}>
                        <span className={`h-1.5 w-1.5 rounded-full ${STAGE_META[p.id].bar}`} />{p.n} {STAGE_META[p.id].label.toLowerCase()}
                    </span>
                ))}
            </div>
        </div>
    );
};
